import { GlobalStateContext } from "contexts/GlobalStateContext"
import { useContext, useCallback, useEffect } from "react"
import { addIdForDataGrid, isNumeric } from "utils";
import { alertConfirmDelete, alertError } from "components/Alert";
import { initFilterData } from "./initData"
import { billingNoteApiNm } from "constants/billingNoteConstant";
import dayjs from "dayjs";
import { branchApiNm } from "branch/constant/branchApiNm";

const { useState } = require("react")

let oldSndDocDte  = null
let bnIds = []
let selectedId = 0;
let lastFilter = null;
const useBillingNoteManagement = () =>{
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogSelectDateOpen, setDialogSelectDateOpen] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const { ax } = useContext(GlobalStateContext);
  
  const getBillingNote = useCallback((filter) => {
    ax.post(branchApiNm.getBillingNote365, filter).then(value=>{
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "BNId"))
        lastFilter = {...filter}
      }
    })
  }, [ax])

  

  const openDialog = useCallback((id) => {
    console.log("in openDialog selectedId::", id)
    setDialogOpen(true);
    selectedId = id
  }, [])

  const insertUpdateBillingNote = useCallback((dialogData) => {
    if(!isNumeric(dialogData.WhtPrct)){
      alertError("หัก ณ ที่จ่ายเป็นตัวเลขเท่านั้น")
      return;
    }
    if(!isNumeric(dialogData.UntPr)){
      alertError("ราคาเป็นตัวเลขเท่านั้น")
      return;
    }
    let result;
    
    const postData = {...dialogData, getArgs: lastFilter}
    if (dialogData.BNId > 0) {
      result = ax.post(billingNoteApiNm.updateBillingNote, postData);
    } else {
      result = ax.post(billingNoteApiNm.insertBillingNote, postData);
    }

    result.then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "BNId"));
        setDialogOpen(false);
      }
    })
  }, [ax])

  const deleteBillingNote = useCallback((id) => {
    alertConfirmDelete(() => {
      ax.post(billingNoteApiNm.deleteBillingNote, { BNId: id, getArgs: lastFilter }).then(value => {
        if (value.data) {
          setDataTable(addIdForDataGrid(value.data, "BNId"));
          setDialogOpen(false);
        }
      })
    })
  }, [ax])

  const handleSendDocDteClick = useCallback((row)=>{
    if(row.id === 0) return

    if (selectionModel.includes(row.BNId)) {
      bnIds = [...selectionModel]
    } else {
      bnIds = [row.BNId]
    }
    oldSndDocDte = row.SndDocDte
    setDialogSelectDateOpen(true);
  }, [ selectionModel])

  const onFinishDialog = useCallback(()=>{
    setDialogOpen(false)
    getBillingNote(lastFilter)
  }, [getBillingNote])

  const onSelectDateDialogFinish = useCallback((data)=>{ 
    console.log("onSelectDateDialogFinish data::", data)
    const postData = {
      BNIds: bnIds,
      SndDocDte: dayjs(data).format("YYYY-MM-DD"),
      getArgs: lastFilter
    }
    ax.post(billingNoteApiNm.updateSndDocDte, postData).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "BNId"));
      }
    })
  }, [ax])


  useEffect(()=>{
    getBillingNote(initFilterData);
  }, [getBillingNote])

  return {
    state: {dataTable, selectedId, dialogOpen, selectionModel, dialogSelectDateOpen, bnIds, oldSndDocDte},
    fn: {openDialog, setDialogOpen, getBillingNote, insertUpdateBillingNote, deleteBillingNote
      , onFinishDialog, setSelectionModel, setDialogSelectDateOpen, onSelectDateDialogFinish, handleSendDocDteClick}
  }
}

export default useBillingNoteManagement